import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { t } = useTranslation();
  const { isAuthenticated, logout } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Check if we're being redirected due to session expiration
    const state = location.state as { expired?: boolean } | null;
    if (state?.expired) {
      // Clear auth state
      logout();
    }
  }, [location.state, logout]);

  if (!isAuthenticated) {
    // Check if we're being redirected due to session expiration
    const state = location.state as { expired?: boolean } | null;

    if (state?.expired) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            p: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="h5" gutterBottom>
            {t("auth.text.sessionHasExpired")}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t("auth.text.logAgainContinue")}
          </Typography>
        </Box>
      );
    }

    // Regular redirect to login page while saving the attempted URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
